import Grid from "@mui/material/Grid";

import { FormZeffyLoader } from "@/forms-design-system/FormZeffyLoader/FormZeffyLoader";

export interface ThemedContainerLoaderProps {
  fullPage?: boolean;
}

export const ThemedContainerLoader = ({ fullPage }: ThemedContainerLoaderProps) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      sx={
        fullPage
          ? {
              height: "100vh",
              ["@supports (height: 100dvh)"]: { height: "100dvh" },
            }
          : { height: "100%" }
      }
    >
      <FormZeffyLoader size="large" />
    </Grid>
  );
};
